// extracted by mini-css-extract-plugin
export default {"teamInfoContainer":"company-info_teamInfoContainer__A+UP7"};